// *******************************************************************************
// Add class to body after some scroll
// *******************************************************************************
function addScrollingClass() {
  const topOffset = document.documentElement.scrollTop || document.body.scrollTop;
  document.body.classList.toggle('is-scrolled', topOffset > 20);
}

let ticking = false;
document.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      addScrollingClass();
      ticking = false;
    });
    ticking = true;
  }
});

let lastScrollTop = 0;
window.addEventListener(
  'scroll',
  () => {
    const isScrolledTop = window.pageYOffset || document.documentElement.scrollTop;
    document.body.classList.toggle('is-scrolled-up', isScrolledTop < lastScrollTop);
    lastScrollTop = isScrolledTop <= 0 ? 0 : isScrolledTop;

    if (windowWidth() > breakpointMd) {
      document.querySelectorAll('.menu__item.is-open-submenu').forEach((item) => toggleSubMenuClass(item, false));
      document.querySelector('.language-switch.is-open')?.classList.remove('is-open');
    }
  },
  false,
);

// *******************************************************************************
// Header Clock
// *******************************************************************************

const siteHeaderClock = document.querySelector('.site-header__clock');

if (siteHeaderClock) {
  const updateClockUI = () => {
    const clockElem = siteHeaderClock.querySelector('.site-header__clock-time');
    if (!clockElem) return;

    const clockEle = siteHeaderClock; // container
    const isClosed = clockElem.getAttribute('data-is-closed') === '1';
    const remainingText = clockElem.getAttribute('data-remaining-text');

    if (isClosed) {
      clockEle.classList.add('is-closed');
    } else {
      clockEle.classList.remove('is-closed');
    }

    if (remainingText) {
      clockElem.textContent = remainingText;
    }
  };

  const axiosUpdateHeaderClock = async () => {
    const action = 'updateHeaderClock';
    const content = siteHeaderClock.querySelector('.site-header__clock-content');
    if (!content) return;

    try {
      const { data } = await axios.post(localData.siteURL, {
        action,
        nonce: await getNonceForAction(action),
      });

      if (data?.data?.html_clock) {
        content.innerHTML = data.data.html_clock;
        updateClockUI();
      }
    } catch (err) {
      console.error(err);
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    axiosUpdateHeaderClock();
    setInterval(axiosUpdateHeaderClock, 60000); // refresh every minute
  });
}

// *******************************************************************************
// Toggle header classes
// *******************************************************************************

const toggleMenuClass = (toggle) => {
  document.body.classList.toggle('is-open-menu', toggle);
};

attachEvent('.hamburger', 'click', () => {
  const isOpen = document.body.classList.contains('is-open-menu');
  toggleMenuClass(!isOpen);
});
